import { useRef, useCallback } from 'react';

export const useMouseInteraction = (containerRef, onSelection) => {
  const eventListenersRef = useRef({});

  const setupEventListeners = useCallback((raycaster, camera, scene, anchors) => {
    if (!containerRef.current) return;

    const handleTouchStart = (event) => {
      event.preventDefault();
      if (!containerRef.current) return;
      const touch = event.touches[0];
      const rect = containerRef.current.getBoundingClientRect();
      const x = ((touch.clientX - rect.left) / rect.width) * 2 - 1;
      const y = -((touch.clientY - rect.top) / rect.height) * 2 + 1;
      onSelection(x, y, raycaster, camera, scene, anchors);
    };

    const handleMouseDown = (event) => {
      if (!containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      const y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
      onSelection(x, y, raycaster, camera, scene, anchors);
    };

    containerRef.current.addEventListener('touchstart', handleTouchStart, false);
    containerRef.current.addEventListener('mousedown', handleMouseDown, false);

    eventListenersRef.current = {
      touchstart: handleTouchStart,
      mousedown: handleMouseDown
    };

    containerRef.current.userData = {
      ...containerRef.current.userData,
      eventListeners: eventListenersRef.current
    };
  }, [containerRef, onSelection]);

  const removeEventListeners = useCallback(() => {
    if (containerRef.current && containerRef.current.userData && containerRef.current.userData.eventListeners) {
      const { touchstart, mousedown } = containerRef.current.userData.eventListeners;
      if (touchstart) containerRef.current.removeEventListener('touchstart', touchstart);
      if (mousedown) containerRef.current.removeEventListener('mousedown', mousedown);
    }
  }, [containerRef]);

  return {
    setupEventListeners,
    removeEventListeners
  };
};
